import { createAsyncThunk } from "@reduxjs/toolkit"

import { loadFromLocalStorage } from "src/localStorage"

import userReducers from "../reducers"

export const thunk = createAsyncThunk("user/loadFromStorage", async () => {
  const appData = loadFromLocalStorage()
  const result = {}
  if (appData?.accessToken) result.accessToken = appData.accessToken
  if (appData?.refreshToken) result.refreshToken = appData.refreshToken
  return result
})

export const onSucceed = userReducers.setData

const thunkObject = { thunk, onSucceed }
export default thunkObject
